<form [formGroup]="form">
  <eps-select
    formControlName="senderShipTos"
    label="HOME_MARKET_BONUS.TABLE.SENDER"
    [options]="senderShipTos"
    [labelWidth]="labelWidth"
    [busy]="shipTosLoading"
    multiple
    hideOptionalMarker
  ></eps-select>
  <eps-select
    formControlName="receiverShipTos"
    label="HOME_MARKET_BONUS.TABLE.RECEIVER"
    [options]="receiverShipTos"
    [labelWidth]="labelWidth"
    [busy]="shipTosLoading"
    multiple
    hideOptionalMarker
  ></eps-select>
  <eps-select
    formControlName="receiverRoles"
    label="HOME_MARKET_BONUS.TABLE.RECEIVER_ROLE"
    [options]="roles"
    [labelWidth]="labelWidth"
    multiple
    hideOptionalMarker
  ></eps-select>
  <eps-toggle
    trueLabel="HOME_MARKET_BONUS.FILTER.TYPE_ACTIVE"
    falseLabel="HOME_MARKET_BONUS.FILTER.TYPE_HISTORICAL"
    label="HOME_MARKET_BONUS.FILTER.TYPE"
    formControlName="filterActive"
    [labelWidth]="labelWidth"
    hideOptionalMarker
  ></eps-toggle>
</form>
